var map = {
	"./dazed.png": "e110",
	"./di.png": "da29",
	"./guardian.jpg": "468f",
	"./huffpost.jpg": "8daa",
	"./ilsole24ore.png": "da33",
	"./krautreporter.png": "16d1",
	"./mutinerie.png": "3aec",
	"./nation.png": "6a45",
	"./nesta.png": "92fc",
	"./newyorker.jpg": "79af",
	"./opengov.png": "71d0",
	"./republica.png": "b635",
	"./wired.png": "905f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3600";